export default __webpack_public_path__ + "static/media/folder.46e2ed02.svg";